import { render, staticRenderFns } from "./PaymentChargebackDetailModal.vue?vue&type=template&id=08606db4&scoped=true&"
import script from "./PaymentChargebackDetailModal.vue?vue&type=script&lang=js&"
export * from "./PaymentChargebackDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentChargebackDetailModal.vue?vue&type=style&index=0&id=08606db4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08606db4",
  null
  
)

export default component.exports